import ReceiptMinimalIcon from '@bv/components/icons/ReceiptMinimalIcon.vue';
import { RouteRecordRaw } from '@bv/router';

import { accountDetailsBreadcrumbs } from '@/router/main/breadcrumbs';
import { canAccessNewBillingFeatures } from '@/utils/workspace-info';

export const billingRoutes: RouteRecordRaw[] = [
  {
    path: '/subscription-plans/:serviceUniqueName/:subscriptionId?',
    name: 'subscription-plan-selector',
    meta: {
      header: { title: 'GLOBAL.ACCOUNT_DETAILS', icon: ReceiptMinimalIcon },
      breadcrumbs: accountDetailsBreadcrumbs({
        label: 'subscription_plan_selector.title_trans',
        route: { name: 'subscription-plan-selector' },
      }),
    },
    component: () => import('@/components/subscription-plan-selector/index.vue'),
  },
  {
    path: 'account-details',
    name: 'account-details',
    redirect: { name: 'subscription-details' },
    meta: {
      canAccess: canAccessNewBillingFeatures,
      header: { title: 'GLOBAL.ACCOUNT_DETAILS', icon: ReceiptMinimalIcon },
      sidebar: [
        {
          title: 'subscription_details.sidebar.subscriptions',
          route: { name: 'subscription-details-default' },
          icon: 'bvi-receipt',
        },
        // {
        //   title: 'subscription_details.sidebar.saved_cards',
        //   route: { name: 'payment-methods' },
        //   icon: 'bvi-card',
        // },
        {
          title: 'subscription_details.sidebar.history',
          route: { name: 'subscription-history' },
          icon: 'bvi-history',
        },
      ],
    },
    children: [
      {
        path: '/subscriptions',
        name: 'subscription-details',
        redirect: { name: 'subscription-details-default' },
        meta: {
          breadcrumbs: accountDetailsBreadcrumbs({
            label: 'subscription_details.sidebar.subscriptions',
            route: { name: 'subscription-details-default' },
          }),
        },
        children: [
          {
            path: '',
            name: 'subscription-details-default',
            component: () => import('@/views/Main/subscriptions/index.vue'),
          },
          {
            path: ':serviceUniqueName',
            name: 'subscription-details-by-service',
            component: () => import('@/views/Main/subscriptions/index.vue'),
          },
        ],
      },
      // {
      //   path: '/payment-methods',
      //   name: 'payment-methods',
      //   meta: {
      //     title: 'subscription_details.sidebar.saved_cards',
      //     icon: 'CreditCardIcon',
      //   },
      //   component: () => import('@/views/Main/PaymentCards/index.vue'),
      // },
      {
        path: '/subscription-history',
        name: 'subscription-history',
        meta: {
          breadcrumbs: accountDetailsBreadcrumbs({
            label: 'subscription_details.sidebar.history',
            route: { name: 'subscription-history' },
          }),
        },
        component: () => import('@/views/Main/subscriptions/history/index.vue'),
      },
    ],
  },
  {
    path: '/payment-status/:workspaceId?/:serviceUniqueName?',
    name: 'payment-status',
    meta: {
      header: { title: 'GLOBAL.SUCCESS_TRANS' },
      breadcrumbs: [
        {
          label: 'GLOBAL.SUCCESS_TRANS',
          route: { name: 'payment-status' },
        },
      ],
    },
    component: () => import('@/views/Main/SuccessPaymentPage.vue'),
  },
];
